<template>
  <button
    :disabled="countChecked === 1 && !disabled ? false : true"
    @click="$emit('click')"
    class="btn btn-primary btn-block"
  >
    <i class="fa fa-pencil-alt"></i> Sửa <slot></slot>
  </button>
</template>
<script>
export default {
  name: "edit-button",
  props: {
    disabled: {},
    countChecked: {
      type: Number,
      required: true
    }
  }
};
</script>
